import { Component } from '@verndale/core';
import { rovingIndex } from 'roving-ux';
import { debounce } from '../helpers/debounce';

class TabbedFeaturedContent extends Component {
  constructor(el) {
    super(el);
    this.defaultValue = this.el.dataset.defaultValue;
    this.panels = this.setTabPanels();
    this.currentCard = this.el.querySelector(
      '.tabbed-featured-content__panel.active .featured-content-card'
    );

    if (
      this.dom.tabsList &&
      (this.dom.tabsList).querySelectorAll(
        '.tabbed-featured-content__tab'
      ).length > 0
    ) {
      rovingIndex({
        element: this.dom.tabsList,
        target: '.tabbed-featured-content__tab'
      });
    }

    this.defaultValue = this.el.dataset.defaultValue;
    const selectedTab = this.el.querySelector(
      `.tabbed-featured-content__tab[data-value="${this.defaultValue}"]`
    );

    if (!this.defaultValue || !selectedTab) {
      const firstTab = this.el.querySelector(
        '.tabbed-featured-content__tab'
      );

      const firstPanel = this.el.querySelector(
        '.tabbed-featured-content__panel'
      );

      const firstCard = firstPanel?.querySelector(
        '.featured-content-card'
      );

      if (firstTab && firstPanel && firstCard) {
        this.defaultValue = firstTab.dataset.value;
        firstTab.classList.add('active');
        firstPanel.classList.add('active');
        this.currentCard = firstCard;
      }
    }

    this.panels = this.setTabPanels();

    this.init();
  }

  setupDefaults() {
    this.dom = {
      container: this.el,
      tabsList: this.el.querySelector(
        '.tabbed-featured-content__tabs-list'
      ),
      tabs: this.el.querySelectorAll(
        '.tabbed-featured-content__tab'
      ),
      panels: this.el.querySelectorAll(
        '.tabbed-featured-content__panel'
      ),
      cards: this.el.querySelectorAll('.featured-content-card'),
      dropdown: this.el.querySelector('.field__select'),
      panelsContainer: this.el.querySelector(
        '.tabbed-featured-content__content-wrapper'
      )
    };
  }

  addListeners() {
    (this.dom.tabs).forEach(trigger => {
      trigger.addEventListener('click', this.handleTabClick.bind(this));
    });

    (this.dom.dropdown)?.addEventListener(
      'change',
      this.handleDropdownChange.bind(this)
    );

    window.addEventListener(
      'resize',
      debounce(this.handleResize.bind(this), 250)
    );
  }

  setTabPanels() {
    let panels = {};

    (this.dom.tabs)?.forEach(tab => {
      const value = tab.dataset.value;
      const id = tab.id;
      const panel = this.el.querySelector(
        `[aria-labelledby="${id}"]`
      );

      if (value) {
        panels = { ...panels, [value]: panel };
      }
    });

    return panels;
  }

  setActiveTab(button) {
    const activeTab = button;
    const activePanel = activeTab.dataset.value;

    if (activePanel) {
      (this.dom.panels).forEach(panel => {
        panel.classList.add('tabbed-featured-content__panel--hidden');
        panel.classList.remove('.active');
      });

      (this.dom.tabs).forEach(tab => {
        tab.classList.remove('active');
        tab.blur();
        tab.ariaSelected = 'false';
      });

      const currentPanel =
        this.panels[activePanel];

      currentPanel?.classList.remove('tabbed-featured-content__panel--hidden');
      currentPanel?.classList.add('active');

      const currentCard = currentPanel.querySelector(
        '.featured-content-card'
      );
      currentCard?.focus();

      activeTab.classList.add('active');
      activeTab.ariaSelected = 'true';

      if (this.dom.dropdown)
        (this.dom.dropdown).value = activePanel;

      this.calculateOffset(currentCard);
      this.getMaxCardHeight();

      setTimeout(() => {
        this.calculateOffset(currentCard);
        this.getMaxCardHeight();
      });
    }
  }

  init() {
    if (this.defaultValue) {
      const defaultTab = this.el.querySelector(
        `.tabbed-featured-content__tab[data-value="${this.defaultValue}"]`
      );

      if (defaultTab) {
        this.setActiveTab(defaultTab);
      }
    } else if (this.dom.tabs) {
      this.setActiveTab(
        (this.dom.tabs).item(0)
      );
    }

    this.getMaxCardHeight();
  }

  calculateOffset(card = null) {
    const currentCard = card || this.currentCard;
    const height = currentCard?.offsetHeight;

    if (this.dom.container && height) {
      const container = this.dom.container;
      const containerHeight = container.offsetHeight;
      const offsetHeight = height - containerHeight;

      if (offsetHeight !== 0) {
        container.style.setProperty(
          '--tab-content-offset',
          `${offsetHeight > 0 ? offsetHeight / 2 : 0}px`
        );
      }
    }
  }

  getMaxCardHeight() {
    (this.dom.panelsContainer).classList.add(
      '.tabbed-featured-content__content-wrapper--hidden'
    );

    const maxHeight = Math.max(
      ...Array.from(this.dom.cards).map(
        panel => panel.offsetHeight
      )
    );

    (this.dom.container).style.setProperty(
      '--min-featured-card-height',
      `${maxHeight}px`
    );

    (this.dom.panelsContainer).classList.remove(
      '.tabbed-featured-content__content-wrapper--hidden'
    );
  }

  handleTabClick(e) {
    const target = e.target;
    this.setActiveTab(
      target.classList.contains('tabbed-featured-content__tab')
        ? target
        : (target.parentElement)
    );
  }

  handleResize() {
    this.getMaxCardHeight();
    this.calculateOffset();
    setTimeout(() => {
      this.getMaxCardHeight();
      this.calculateOffset();
    });
  }

  handleDropdownChange(e) {
    const target = e.target;
    const value = target.value;
    const tab = this.el.querySelector(
      `.tabbed-featured-content__tab[data-value="${value}"]`
    );

    if (tab) {
      this.setActiveTab(tab);
    }
  }
}

export default TabbedFeaturedContent;
